<div *ngIf="user$ | async as user">
  <div *ngIf="!user?.premiumGames?.includes('wheretaken')" class="lg:hidden end-mobile-ad flex items-center justify-start flex-col">
      <!-- adngin-end_mobile-0  -->
      <a
        routerLink="/passport"
        class="remove-ads-cta mb-1"
        *ngIf="!user?.premiumGames?.includes('wheretaken')"
      >
        Remove ads
        <span class="remove-ads-cta__icon">
          <img src="/assets/icons/teuteuf_passport.png" width="14" height="14" alt="" />
        </span>
      </a>
      <div id="adngin-end_mobile-0"></div>
  </div>
</div>
